(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/collections/user-competitions.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/collections/user-competitions.js'); 
'use strict';

svs.competition.core.collections.UserCompetitions = Backbone.Collection.extend({
  url: svs.core.jupiter.url() + '/player/competitions',
  initialize: function() {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      if (svs.competition.core.data.userCompetitions) {
        this.reset(svs.competition.core.data.userCompetitions, {
          parse: true
        });
      } else {
        this.fetch();
      }
    }
  },
  parse: function(data) {
    if (!data.error) {
      var competitions = data.competitions || data;
      return _.filter(svs.competition.core.data.competitions, function(
        competition
      ) {
        return !_.isEmpty(
          _.where(competitions, { competitionId: competition.id })
        );
      });
    }
    svs.competition.core.logger.error(
      'Error parsing competitions. ' + data.error
    );
  }
});

 })(window);